import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { KetMoveLayerManuComponent } from './move-layer-manu.component'
import { NzRadioModule } from 'ng-zorro-antd/radio'
import { FormsModule } from '@angular/forms'
import { NzSelectModule } from 'ng-zorro-antd/select'
import { NzEmptyModule } from 'ng-zorro-antd/empty'

@NgModule({
  declarations: [KetMoveLayerManuComponent],
  entryComponents: [KetMoveLayerManuComponent],
  imports: [CommonModule, NzRadioModule, FormsModule, NzSelectModule, NzEmptyModule],
  exports: [KetMoveLayerManuComponent],
})
export class KetMoveLayerManuModule {}
